/** DEPRECATED - do not use in new code **/
const getExtraPersonCharge = (unitTypeOccupancy, ratePlan, adults) => {
  if (!unitTypeOccupancy.hasExtraPersonCharge) {
    return 0
  }

  if (adults <= unitTypeOccupancy.standardOccupancy || adults > unitTypeOccupancy.maxOccupancy) {
    return 0
  }

  const extraPersonCount = adults - unitTypeOccupancy.standardOccupancy

  return extraPersonCount * unitTypeOccupancy.extraPersonCharge * ratePlan.nights
}

export default getExtraPersonCharge
